import { render, staticRenderFns } from "./Payment-Return.vue?vue&type=template&id=3ad95fe9&scoped=true&"
import script from "./Payment-Return.vue?vue&type=script&lang=js&"
export * from "./Payment-Return.vue?vue&type=script&lang=js&"
import style0 from "./Payment-Return.vue?vue&type=style&index=0&id=3ad95fe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad95fe9",
  null
  
)

export default component.exports